module.exports = __webpack_public_path__ + "media/images/flags/ro-ea966c3dc0adf3d08a0048f1af8e322c.svg";